module.exports = __webpack_public_path__ + "static/media/instructivooc6.5a9ad1dd.png";